import { ContentAggregatorItemSchemeDefinition } from "./content-aggregator-item-types";
import { BackgroundColor } from "../../background/constants/background-types";

import * as AllColors from "../../../constants/colors";
import { toConstantCase } from "../../../utils/string-format";
import { createContentAggregatorItemMapDefinition } from "../../../utils/scheme-helper";

export const CONTENT_AGGREGATOR_ITEM_LARGE_HEADLINE = "large";
export const CONTENT_AGGREGATOR_ITEM_SMALL_HEADLINE = "small";

export const CONTENT_AGGREGATOR_ITEM_HEADLINE_SIZE = [
  CONTENT_AGGREGATOR_ITEM_LARGE_HEADLINE,
  CONTENT_AGGREGATOR_ITEM_SMALL_HEADLINE
] as const;

export const CONTENT_AGGREGATOR_ITEM_LAYOUT_LIST = "list";
export const CONTENT_AGGREGATOR_ITEM_LAYOUT_LIST_EXPANDED = "list_expanded";
export const CONTENT_AGGREGATOR_ITEM_LAYOUT_TILE = "tile";

export const CONTENT_AGGREGATOR_ITEM_LAYOUTS = [
  CONTENT_AGGREGATOR_ITEM_LAYOUT_LIST,
  CONTENT_AGGREGATOR_ITEM_LAYOUT_LIST_EXPANDED,
  CONTENT_AGGREGATOR_ITEM_LAYOUT_TILE
] as const;

function createSchemes() {
  let newSchemes: AllColors.ContentAggregatorItemSchemeConfiguration<ContentAggregatorItemSchemeDefinition> = {};
  AllColors.CONTENT_AGGREGATOR_ITEM_SCHEMES.forEach((element) => {
    newSchemes[element.schemeName] = {
      contentColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      dateColorOnImage: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      backgroundColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      backgroundColorShade: AllColors[`COLOR_${toConstantCase(element.schemeName)}_SHADE_1`],
      leftBorderColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_TINT_1`],
      linkColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      linkHoverColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_SHADE_1`],
      contentBackground: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      hoverColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_SHADE_1`],
      listButtonScheme: ""
    };
    if (element.scheme) {
      newSchemes[element.schemeName] = { ...newSchemes[element.schemeName], ...element.scheme };
    }
  });
  return newSchemes;
}

export const CONTENT_AGGREGATOR_ITEM_SCHEME_CONFIG: AllColors.ContentAggregatorItemSchemeConfiguration<ContentAggregatorItemSchemeDefinition> = createSchemes();

export const CONTENT_AGGREGATOR_ITEM_SCHEME_MAP: Map<
  BackgroundColor | "default",
  ContentAggregatorItemSchemeDefinition
> = new Map(
  Object.entries(createContentAggregatorItemMapDefinition()).map(([background, config]) => [
    background as BackgroundColor,
    CONTENT_AGGREGATOR_ITEM_SCHEME_CONFIG[config as string]
  ])
);
